import React from "react";

const Plan = () => (
  <>
    <section id={"plan"} className={"section effect-section"}>
      <div className={"container"}>
        <div className={"row"}>
          <div className={"col-lg-6 min-h-350px"}>
            <div
              className={
                "p-100px-tb p-50px-r lg-p-0px-r d-flex align-items-center h-100"
              }
            >
              <div>
                <h1 className={"display-4 font-w-700 white-color"}>
                  Development Plan
                </h1>
                <p className={"lead white-color"}>
                  Specialized, tailor-made software development for each client
                </p>
                <div className={"p-20px-t"}>
                  <a
                    className={"m-btn m-btn-radius m-btn-dark"}
                    href={"/PayPlans"}
                  >
                    <span className={"m-btn-inner-text"}>Learn more</span>
                    <span className={"m-btn-inner-icon arrow"} />
                  </a>
                </div>
              </div>
            </div>
            <div
              className={"mask-50vw left parallax"}
              style={{
                backgroundImage: `url(${require("../images/plandev.webp")})`,
              }}
            >
              <div className={"mask opacity-8 theme-bg"} />
            </div>
          </div>
          <div className={"col-lg-6 min-h-350px"}>
            <div
              className={
                "p-100px-tb p-50px-r lg-p-0px-r d-flex align-items-center h-100"
              }
            >
              <div>
                <h1 className={"display-4 font-w-700 white-color"}>
                  Partner Plan
                </h1>
                <p className={"lead white-color"}>
                  We become your strategic ally in the technological growth of
                  your business.
                </p>
                <div className={"p-20px-t"}>
                  <a
                    className={"m-btn m-btn-radius m-btn-dark"}
                    href={"/PayPlans"}
                  >
                    <span className={"m-btn-inner-text"}>Learn more</span>
                    <span className={"m-btn-inner-icon arrow"} />
                  </a>
                </div>
              </div>
            </div>
            <div
              className={"mask-50vw right parallax"}
              style={{
                backgroundImage: `url(${require("../images/planpar.webp")})`,
              }}
            >
              <div className={"mask opacity-8 theme-bg"} />
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
);

export default Plan;
